export const getTosFromStorage = (key: string): boolean => {
  try {
    const stored = localStorage.getItem(key)
    return stored === 'true'
  } catch {
    return false
  }
}

export const setTosToStorage = (key: string, value: boolean): void => {
  try {
    localStorage.setItem(key, value.toString())
  } catch {
    /* eslint-disable-line no-empty */
  }
}

export const clearTosFromStorage = (key: string): void => {
  try {
    localStorage.removeItem(key)
  } catch {
    /* eslint-disable-line no-empty */
  }
}

export const clearAllTosStorage = (userId: string, flowName?: string): void => {
  const { tosKey, prepaidTosKey } = getTosStorageKeys(userId, flowName)
  clearTosFromStorage(tosKey)
  clearTosFromStorage(prepaidTosKey)
}

export const getTosStorageKeys = (userId: string, flowName?: string) => {
  const safeUserId = userId || 'anonymous'
  const flow = flowName || 'default'
  const baseKey = `InstantInkSignupSession/${flow}/${safeUserId}`

  return {
    tosKey: `${baseKey}/tos_accepted`,
    prepaidTosKey: `${baseKey}/prepaid_tos_accepted`,
    sessionIdentifier: safeUserId
  }
}
